import { Component, OnInit, Optional } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { PageTemplate } from '@nousmedis/cc-types';
import { pageTemplateFormFields } from '../../../schemas/page-template-form.schema';
import { PageTemplateService } from '../../../services/page-template.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthModel } from '@nousmedis/nm-guard-auth';

@Component({
  selector: 'app-page-template-form',
  templateUrl: './page-template-form.component.html',
  styleUrls: ['./page-template-form.component.scss']
})
export class PageTemplateFormComponent implements OnInit {
  form = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];

  title = 'PAGE.NEW_TEMPLATE';
  imageSrc = '';
  imageName = '';
  exampleRows = 1;
  exampleCols = 1;
  loadedForm = false;

  private idTemplate = '';
  private idUser = '';

  constructor(
    private pageTemplateService: PageTemplateService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private router: Router,
    private auth: AuthModel,
    @Optional() private dialogConf?: DynamicDialogConfig,
    @Optional() private dialogRef?: DynamicDialogRef,
  ) {}

  ngOnInit(): void {
    this.idTemplate = this.dialogConf?.data?.idTemplate ?? this.route.snapshot.paramMap.get('id') ?? '';
    this.idUser = this.dialogConf?.data?.idUser ?? this.auth.getCurrentUser().id ?? '';
    this.fields = pageTemplateFormFields(this.translate);

    if (this.idTemplate) {
      this.title = 'PAGE.EDIT_TEMPLATE';
      this.pageTemplateService.getTemplate(this.idTemplate).subscribe((data: PageTemplate) => {
        if (data.imageData) {
          this.imageSrc = data.imageData;
          this.imageName = data.imageName;
        }
        this.model = {
          id: data.id,
          name: data.name,
          columns: data.columns,
          rows: data.rows,
          cells: data.cells,
          createdBy: data.createdBy,
          updatedBy: this.idUser,
        };
        this.exampleCols = data.columns;
        this.exampleRows = data.rows;
        this.loadedForm = true;
      });
    } else {
      this.model = {
        id: undefined,
        name: '',
        columns: 1,
        rows: 1,
        cells: [{
          rowPosition: 1, rowWidth: 1,
          columnPosition: 1, columnWith: 1,
          visible: true, cellNumber: 0,
          id: undefined, createdBy: this.idUser,
        }],
        createdBy: this.idUser,
        updatedBy: this.idUser,
      };
      this.loadedForm = true;
    }

    this.form.valueChanges.subscribe(() => {
      this.exampleCols = Number(this.model.columns) || 1;
      this.exampleRows = Number(this.model.rows) || 1;
    });
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        this.imageName = file.name;
      };
      reader.readAsDataURL(file);
    }
  }

  modifiedCells(cells: any): void {
    this.model = { ...this.model, cells };
  }

  save(): void {
    const template: PageTemplate = {
      ...this.model,
      imageData: this.imageSrc || '',
      imageName: this.imageName || '',
    };

    if (this.idTemplate) {
      this.pageTemplateService.updateTemplate(template).subscribe((data) => {
        this.dialogRef ? this.dialogRef.close(data) : this.router.navigate(['/page-templates/list']);
      });
    } else {
      this.pageTemplateService.setTemplate(template).subscribe((data) => {
        this.dialogRef ? this.dialogRef.close(data) : this.router.navigate(['/page-templates/list']);
      });
    }
  }

  cancel(): void {
    this.dialogRef ? this.dialogRef.close() : this.router.navigate(['/page-templates/list']);
  }
}
